import React, { Component, Fragment } from "react"
import Async from "react-select"
import { StyleServices, DevelopmentServices } from "../../services"
import PageHeader from "../../components/Page/PageHeader/PageHeader"
import Field from "../../components/Common/Field/Field"
import Button from "../../components/Buttons/Button"
import moment from "moment"
import PrintTechnical from "./printTechnical"
import printer from "../../assets/images/printer.png"
import Loading from "../../components/Common/Loading"

class TechnicalIssues extends Component {
  state = {
    action: "",
    magnumStyleId: null,
    styleReferenceId: null,
    styleReferenceCode: " ",
    styleNumber: " ",
    customerName: " ",
    departmentName: " ",
    magnumStyleName: " ",
    createdBy: " ",
    createdAt: null,
    technicalIssue: {},
    technicalData: {},
    isLoading: false,
    disabled: false
  }

  async componentWillMount() {
    this.setState({
      isLoading: true
    })
    // this.getMagnumStyleNo("");
    if (this.props.location.state) {
      var { styleReferenceId, action, _id } = this.props.location.state;
      action === 'add' && this.getMagnumStyleNo("");
    } else {
      this.getMagnumStyleNo("");
      this.setState({
        isLoading: false
      })
    }
    if (!styleReferenceId && !action && !_id) {
      // this.getMagnumStyleNo("");
      this.setState({
        isLoading: false
      })
    }
    if (styleReferenceId !== "") {
      // this.getMagnumStyleNo("");
      this.setState({
        styleReferenceId,
        action: action
      })
      setTimeout(async () => {
        await this.getStyleReferenceInfo(styleReferenceId);
      }, 200)
      await StyleServices.getStyleInfoByReference(styleReferenceId)
        .then(response => {
          if (response.status === 200) {
            this.setState({
              magnumStyleName: response.text.data.magnumStyleName,
              styleReferenceCode: response.text.data.referenceCode,
              customerName: response.text.data.customerName,
              departmentName: response.text.data.departmentName,
              magnumStyleId: response.text.data.magnumStyleId,
              // styleNumber: response.text.data.styleNumber,
              // createdBy: `${response.text.data.createdBy.firstName}-${response.text.data.createdBy.lastName}`,
              styleReferenceId,
              isLoading: false
            })
          }
          response.status == 401 && this.props.unauthorisedFunc()
        })
        .catch(error => this.props.getalertMessage("error ", error.toString()))
    }

    if (action === 'edit' || action === "view") {
      let search = true
      await StyleServices.getTechnicalIssues(_id)
        .then(response => {
          if (response.status === 200) {
            let jsonData = [];
            if (response.text.data.styleReferenceId) {
              jsonData = [{
                label: response.text.data.styleReferenceCode,
                value: response.text.data.styleReferenceId
              }]
            }
            this.setState({
              styleNoInfo: jsonData,
              technicalIssue: response.text.data,
              magnumStyleName: response.text.data.magnumStyleName,
              styleReferenceCode: response.text.data.styleReferenceCode,
              customerName: response.text.data.customerName || "",
              departmentName: response.text.data.departmentName,
              magnumStyleId: response.text.data.magnumStyleId,
              styleReferenceId: response.text.data.styleReferenceId,
              createdBy: `${response.text.data.createdBy.firstName}-${response.text.data.createdBy.lastName}`,
              isLoading: false,
              action: action,
              disabled: action === "view" && true || false
            })
          }
          response.status == 401 && this.props.unauthorisedFunc()
        })
        .catch(error => this.props.getalertMessage("error ", error.toString()))
      setTimeout(async () => {
        await this.getStyleReferenceInfo(this.state.styleReferenceId);
      }, 200)
    }




    await this.getSampleType()
  }

  getSampleType = () => {
    StyleServices.getSampleType()
      .then(response => {
        if (response.status == 200) {
          let SAMPLETYPELIST = response.text.data.sysData
          // response.text.data.sysData.map(data =>
          //   SAMPLETYPELIST.push({ label: data.name, value: data._id })
          // )
          this.setState({
            SAMPLETYPELIST
          })
        }
      })
      .catch(error => this.props.getalertMessage("error ", error.toString()))
  }

  createTechnicalIssue = () => {
    let technicalIssue = { ...this.state.technicalIssue }
    technicalIssue.styleReferenceId = this.state.styleReferenceId
    technicalIssue.magnumStyleId = this.state.magnumStyleId
    technicalIssue.date =
      technicalIssue.date == null ? new Date() : technicalIssue.date
    StyleServices.createTechnicalIssue(technicalIssue)
      .then(response => {
        if (response.status === 200) {
          if (this.state.action === "" || this.state.action === "add") {
            technicalIssue._id = response.text.data._id
            this.setState({ technicalIssue: { ...this.state.technicalIssue, _id: response.text.data._id } })
          }
          this.props.getalertMessage("success", response.text.message)
        } else if (response.status == 401) {
          this.props.unauthorisedFunc()
        } else {
          this.props.getalertMessage("error", response.text.message)
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  handleChange = (name, value) => {
    // console.log(name, value)
    let technicalIssue = { ...this.state.technicalIssue }
    technicalIssue[name] = value
    this.setState({
      technicalIssue
    })

    // console.log(this.state.technicalIssue)
  }

  technicalIssuePrint = () => {
    setTimeout(() => {
      let technicalData = {}
      const state = { ...this.state }
      const technicalIssue = { ...this.state.technicalIssue }

      if (state.technicalIssue.sampleType !== null) {
        technicalData.sampleType =
          this.state.SAMPLETYPELIST &&
          this.state.SAMPLETYPELIST.length > 0 &&
          this.state.SAMPLETYPELIST.map((data, index) => {
            if (data.value === state.technicalIssue.sampleType) {
              return data.label
            }
          }).filter(Boolean)[0]
      }

      technicalData.styleNumber = state.styleReferenceCode.split('-')[0]
      technicalData.styleReferenceCode = state.styleReferenceCode
      technicalData.customerName = state.customerName
      technicalData.departmentName = state.departmentName
      technicalData.magnumStyleName = state.magnumStyleName
      technicalData.createdAt = technicalIssue.createdAt && moment(technicalIssue.createdAt).format("DD MMM YYYY") || ""
      technicalData.createdBy = state.createdBy

      technicalData.date = moment(technicalIssue.date).format("DD MMM YYYY")
      technicalData.attendees = technicalIssue.attendees
      technicalData.fabric = technicalIssue.fabric
      technicalData.trims = technicalIssue.trims
      technicalData.embelishmentAndEmbroidery =
        technicalIssue.embelishmentAndEmbroidery
      technicalData.pattern = technicalIssue.pattern
      technicalData.cutting = technicalIssue.cutting
      technicalData.makeupOrsewingOrconstruction =
        technicalIssue.makeupOrsewingOrconstruction
      technicalData.safety = technicalIssue.safety
      technicalData.additionalInfo = technicalIssue.additionalInfo
      technicalData.washing = technicalIssue.washing
      technicalData.machinery = technicalIssue.machinery

      this.setState({
        technicalData
      })
    }, 500)
  }

  openPrint = val => {
    let technicalData = JSON.parse(JSON.stringify(this.state.technicalData))
    this.setState(
      {
        technicalData,
        printLoading: true
      },
      () => {
        var divToPrint = document.getElementById(val)
        var newWin = window.open("", "mywindow")
        newWin.document.write(divToPrint.outerHTML)
        newWin.print()
        newWin.close()
      }
    )
  }

  getMagnumStyleNo = value => {
    DevelopmentServices.getMagnumStyleNoWithReference(value)
      .then(response => {
        if (response.status === 200) {
          let jsonData = [];
          response.text.data.map((info, index) => {
            let objData = {};
            objData.label = info.referenceCode;
            objData.value = info.referenceId;
            jsonData.push(objData);
          });
          this.setState({ styleNoInfo: jsonData });
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()));
  };

  getStyleReferenceInfo = styleReferenceId => {
    if (styleReferenceId !== null) {
      styleReferenceId =
        typeof styleReferenceId == "object"
          ? styleReferenceId.value
          : styleReferenceId;
      StyleServices.getStyleInfoByReference(styleReferenceId)
        .then(response => {
          if (response.status === 200) {
            this.setState(
              {
                magnumStyleName: response.text.data.magnumStyleName,
                magnumStyleId: response.text.data.magnumStyleId,
                customer: response.text.data.customer !== "" ? response.text.data.customer : null,
                customerDepartmentId: response.text.data.customerDepartmentId,
                customerName: response.text.data.customerName,
                departmentName: response.text.data.departmentName,
                styleReferenceId
              },
              // () => this.getMagnumStyleById(styleReferenceId),
              // this.getSMVCustomerData(response.text.data.customer, response.text.data.customerDepartmentId)
            );
          }
          response.status == 401 && this.props.unauthorisedFunc();
        })
        .catch(error => {
          this.props.getalertMessage("error", error.toString())
        });
    } else {
      this.setState(
        {
          styleReferenceId: null,
          customer: null,
          customerDepartmentId: null,
          customerName: "",
          departmentName: "",
          magnumStyleId: null,
          magnumStyleName: ""
        },
        () => this.getMagnumStyleNo("")
      );
    }
  };

  render() {
    const {
      styleNumber,
      styleReferenceId,
      styleReferenceCode,
      customerName,
      departmentName,
      magnumStyleName,
      technicalIssue,
      createdAt,
      createdBy
    } = this.state
    if (this.state.isLoading === false) {
      return (
        <Fragment>
          <div class="right-section ">
            <fieldset disabled={this.state.disabled}>
              <span
                className="btn-green-icon pull-right ml-auto mr-5"
                onClick={e => {
                  this.setState({ isLoading: true })
                  setTimeout(() => {
                    this.technicalIssuePrint()
                    this.setState({ isLoading: false })
                    setTimeout(() => this.openPrint("printTechnical"), 500)
                  }, 500)
                }}
              >
                <img src={printer} />
              </span>
              <div class="row nopadding bg-white ">
                <PageHeader
                  header="Technical Issues "
                  history={this.props.history}
                />

                <div class="col-md-12 nopadding thread-consumption-sec1 ">
                  <div class="col-md-2 step-one ">
                    {/* <div class="form-group ">
                    <label for="name ">Style No</label>
                    <span>
                      <h6>{styleNumber}</h6>
                    </span>
                  </div> */}
                    <div class="form-group">
                      <label>Style Ref No.</label>
                      <div class="custom-async-select">
                        <Async
                          name="styleReferenceId"
                          value={styleReferenceId}
                          onInputChange={value => this.getMagnumStyleNo(value)}
                          onChange={val => this.getStyleReferenceInfo(val)}
                          placeholder="Find Style"
                          options={this.state.styleNoInfo}
                          disabled={this.state.disabled}
                          onSelectResetsInput={false}
                          onBlurResetsInput={false}
                        />
                      </div>
                    </div>
                  </div>
                  {/* <div class="col-md-1 step-one ">
                  <div class="form-group ">
                    <label for="name "></label>
                    <span>
                      <h6>{styleReferenceCode}</h6>
                    </span>
                  </div>
                </div> */}
                  <div class="col-md-2 step-one ">
                    <div class="form-group ">
                      <label for="name ">Style Name</label>
                      <span>
                        <h6>{magnumStyleName}</h6>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-4 step-one ">
                    <div class="form-group ">
                      <label for="name ">Customer & Department Name</label>
                      <span>
                        <h6>
                          {`${customerName}-
                          ${departmentName}`}
                        </h6>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-2 step-one ">
                    <div class="form-group ">
                      <label for="name " class="active ">
                        Created Date
                    </label>
                      <p>{technicalIssue.createdAt && moment(technicalIssue.createdAt).format("DD MMM YYYY ") || moment().format("DD MMM YYYY ")}</p>
                    </div>
                  </div>
                  {createdBy !== " " && <div class="col-md-2 step-one">
                    <div class="form-group">
                      <label for="name" class="active">
                        Chart Prepared By
                    </label>
                      <p>{createdBy}</p>
                    </div>
                  </div>}
                </div>
                <div class="col-md-12 nopadding ">
                  <div class="col-md-2 step-one ">
                    <Field
                      isFormGroup={true}
                      inputType="select"
                      inputName="sampleType"
                      value={technicalIssue.sampleType}
                      options={this.state.SAMPLETYPELIST}
                      label="Sample Type"
                      onChange={this.handleChange}
                      disabled={false}
                    />
                  </div>
                  <div class="col-md-2 step-one ">
                    <Field
                      isFormGroup={true}
                      inputType="date"
                      value={technicalIssue.date || new Date()}
                      inputName="date"
                      label={"Date "}
                      onChange={this.handleChange}
                      disabled={false}
                    />
                  </div>
                  <div class="col-md-6 step-one meeting_count ">
                    <Field
                      isFormGroup={true}
                      inputType="text"
                      inputName="attendees"
                      value={technicalIssue.attendees}
                      label={"Who Attended Meeting"}
                      onChange={this.handleChange}
                      disabled={false}
                    />
                  </div>
                </div>
                <div class="col-md-12 ti_table ">
                  <form name="technicalIssues ">
                    <table class="lined bordered responsive-table ">
                      <thead>
                        <tr>
                          <th>Check Point</th>
                          <th>Comments</th>
                          {/* <!-- <th></th> --> */}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Fabric</td>
                          <td>
                            <textarea
                              name="fabric"
                              class="form-control"
                              cols="80"
                              rows="4"
                              value={technicalIssue.fabric}
                              onChange={e =>
                                this.handleChange("fabric", e.target.value)
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>Trims</td>
                          <td>
                            <textarea
                              name="trims"
                              class="form-control"
                              cols="80"
                              rows="4"
                              value={technicalIssue.trims}
                              onChange={e =>
                                this.handleChange("trims", e.target.value)
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <td> Embelishment & Embroidery</td>
                          <td>
                            <textarea
                              name="embelishmentAndEmbroidery"
                              class="form-control"
                              cols="80"
                              rows="4"
                              value={technicalIssue.embelishmentAndEmbroidery}
                              onChange={e =>
                                this.handleChange(
                                  "embelishmentAndEmbroidery",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>PATTERN</td>
                          <td>
                            <textarea
                              name="pattern"
                              class="form-control"
                              cols="80"
                              rows="4"
                              value={technicalIssue.pattern}
                              onChange={e =>
                                this.handleChange("pattern", e.target.value)
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>CUTTING</td>
                          <td>
                            <textarea
                              name="cutting"
                              class="form-control"
                              cols="80"
                              rows="4"
                              value={technicalIssue.cutting}
                              onChange={e =>
                                this.handleChange("cutting", e.target.value)
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>MAKEUP/SEWING/CONSTRUCTION</td>
                          <td>
                            <textarea
                              name="makeupOrsewingOrconstruction"
                              class="form-control"
                              cols="80"
                              rows="4"
                              value={technicalIssue.makeupOrsewingOrconstruction}
                              onChange={e =>
                                this.handleChange(
                                  "makeupOrsewingOrconstruction",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>SAFETY</td>
                          <td>
                            <textarea
                              name="safety"
                              class="form-control"
                              cols="80"
                              rows="4"
                              value={technicalIssue.safety}
                              onChange={e =>
                                this.handleChange("safety", e.target.value)
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>ADDITIONAL INFORMATION</td>
                          <td>
                            <textarea
                              name="additionalInfo"
                              class="form-control"
                              cols="80"
                              rows="4"
                              value={technicalIssue.additionalInfo}
                              onChange={e =>
                                this.handleChange(
                                  "additionalInfo",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>WASHING</td>
                          <td>
                            <textarea
                              name="washing"
                              class="form-control"
                              cols="80"
                              rows="4"
                              value={technicalIssue.washing}
                              onChange={e =>
                                this.handleChange("washing", e.target.value)
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>MACHINERY</td>
                          <td>
                            <textarea
                              name="machinery"
                              class="form-control"
                              cols="80"
                              rows="4"
                              value={technicalIssue.machinery}
                              onChange={e =>
                                this.handleChange("machinery", e.target.value)
                              }
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </form>
                </div>
                <div class="col-md-12 text-center align-items-center ">
                  <Button
                    buttonType="save "
                    buttonName="save "
                    onClick={this.createTechnicalIssue}
                  />
                  <Button
                    buttonType="cancel"
                    buttonName="cancel"
                    history={this.props.history}
                  />
                </div>
              </div>
            </fieldset>
          </div>
          <div id="printTechnical" className="d-none">
            {this.state.printLoading && (
              <PrintTechnical technicalData={this.state.technicalData} />
            )}
          </div>
        </Fragment>
      )
    } else {
      return <Loading />
    }
  }
}

export default TechnicalIssues


// WEBPACK FOOTER //
// ./src/pages/technicalIssues/page.js